var jp = {
  LANG: "jp",
  TEXT: {
    ERROR_TYPES: {
      network: {
        code: 1,
        msg: "\u30D3\u30C7\u30AA\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u30A8\u30E9\u30FC"
      },
      mse: {
        code: 2,
        msg: "\u30B9\u30C8\u30EA\u30FC\u30E0\u8FFD\u52A0\u30A8\u30E9\u30FC"
      },
      parse: {
        code: 3,
        msg: "\u89E3\u6790\u30A8\u30E9\u30FC"
      },
      format: {
        code: 4,
        msg: "\u9593\u9055\u3063\u305F\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8"
      },
      decoder: {
        code: 5,
        msg: "\u30C7\u30B3\u30FC\u30C9\u30A8\u30E9\u30FC"
      },
      runtime: {
        code: 6,
        msg: "\u6587\u6CD5\u30A8\u30E9\u30FC"
      },
      timeout: {
        code: 7,
        msg: "\u518D\u751F\u30BF\u30A4\u30E0\u30A2\u30A6\u30C8"
      },
      other: {
        code: 8,
        msg: "\u305D\u306E\u4ED6\u306E\u30A8\u30E9\u30FC"
      }
    },
    HAVE_NOTHING: "\u30AA\u30FC\u30C7\u30A3\u30AA/\u30D3\u30C7\u30AA\u304C\u6E96\u5099\u3067\u304D\u3066\u3044\u308B\u304B\u60C5\u5831\u304C\u3042\u308A\u307E\u305B\u3093",
    HAVE_METADATA: "\u30AA\u30FC\u30C7\u30A3\u30AA/\u30D3\u30C7\u30AA\u306E\u30E1\u30BF\u30C7\u30FC\u30BF\u306F\u6E96\u5099\u3067\u304D\u3066\u3044\u307E\u3059",
    HAVE_CURRENT_DATA: "\u73FE\u5728\u306E\u518D\u751F\u4F4D\u7F6E\u306B\u95A2\u3059\u308B\u30C7\u30FC\u30BF\u306F\u5229\u7528\u53EF\u80FD\u3067\u3059\u304C\u3001\u6B21\u306E\u30D5\u30EC\u30FC\u30E0/\u30DF\u30EA\u79D2\u3092\u518D\u751F\u3059\u308B\u306E\u306B\u5341\u5206\u306A\u30C7\u30FC\u30BF\u304C\u3042\u308A\u307E\u305B\u3093",
    HAVE_FUTURE_DATA: "\u73FE\u5728\u3001\u5C11\u306A\u304F\u3068\u3082\u6B21\u306E\u30D5\u30EC\u30FC\u30E0\u306E\u30C7\u30FC\u30BF\u304C\u5229\u7528\u53EF\u80FD\u3067\u3059",
    HAVE_ENOUGH_DATA: "\u5229\u7528\u53EF\u80FD\u306A\u30C7\u30FC\u30BF\u306F\u518D\u751F\u3092\u958B\u59CB\u3059\u308B\u306E\u306B\u5341\u5206\u3067\u3059",
    NETWORK_EMPTY: "\u30AA\u30FC\u30C7\u30A3\u30AA/\u30D3\u30C7\u30AA\u304C\u521D\u671F\u5316\u3055\u308C\u3066\u3044\u307E\u305B\u3093",
    NETWORK_IDLE: "\u30AA\u30FC\u30C7\u30A3\u30AA/\u30D3\u30C7\u30AA\u306F\u30A2\u30AF\u30C6\u30A3\u30D6\u3067\u30EA\u30BD\u30FC\u30B9\u304C\u9078\u629E\u3055\u308C\u3066\u3044\u307E\u3059\u304C\u3001\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u304C\u4F7F\u7528\u3055\u308C\u3066\u3044\u307E\u305B\u3093",
    NETWORK_LOADING: "\u30D6\u30E9\u30A6\u30B6\u30FC\u306F\u30C7\u30FC\u30BF\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u3066\u3044\u307E\u3059",
    NETWORK_NO_SOURCE: "\u30AA\u30FC\u30C7\u30A3\u30AA/\u30D3\u30C7\u30AA \u306E\u30BD\u30FC\u30B9\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093",
    MEDIA_ERR_ABORTED: "\u30E6\u30FC\u30B6\u30FC\u306B\u3088\u3063\u3066\u30D5\u30A7\u30C3\u30C1\u30D7\u30ED\u30BB\u30B9\u304C\u4E2D\u6B62\u3055\u308C\u307E\u3057\u305F",
    MEDIA_ERR_NETWORK: "\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F",
    MEDIA_ERR_DECODE: "\u30C7\u30B3\u30FC\u30C9\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F",
    MEDIA_ERR_SRC_NOT_SUPPORTED: "\u30AA\u30FC\u30C7\u30A3\u30AA/\u30D3\u30C7\u30AA \u306E\u5F62\u5F0F\u304C\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u307E\u305B\u3093",
    REPLAY: "\u30EA\u30D7\u30EC\u30A4",
    ERROR: "\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u306E\u63A5\u7D9A\u306B\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F",
    PLAY_TIPS: "\u30D7\u30EC\u30A4",
    PAUSE_TIPS: "\u4E00\u6642\u505C\u6B62",
    PLAYNEXT_TIPS: "\u6B21\u3092\u30D7\u30EC\u30A4",
    DOWNLOAD_TIPS: "\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9",
    ROTATE_TIPS: "\u56DE\u8EE2",
    RELOAD_TIPS: "\u518D\u8AAD\u307F\u8FBC\u307F",
    FULLSCREEN_TIPS: "\u30D5\u30EB\u30B9\u30AF\u30EA\u30FC\u30F3",
    EXITFULLSCREEN_TIPS: "\u30D5\u30EB\u30B9\u30AF\u30EA\u30FC\u30F3\u3092\u7D42\u4E86",
    CSSFULLSCREEN_TIPS: "\u30B7\u30A2\u30BF\u30FC\u30E2\u30FC\u30C9",
    EXITCSSFULLSCREEN_TIPS: "\u30B7\u30A2\u30BF\u30FC\u30E2\u30FC\u30C9\u3092\u7D42\u4E86",
    TEXTTRACK: "\u5B57\u5E55",
    PIP: "\u30DF\u30CB\u30D7\u30EC\u30FC\u30E4\u30FC",
    SCREENSHOT: "\u30B9\u30AF\u30EA\u30FC\u30F3\u30B7\u30E7\u30C3\u30C8",
    LIVE: "\u751F\u653E\u9001",
    OFF: "\u30AA\u30D5",
    OPEN: "\u958B\u3044\u305F",
    MINI_DRAG: "\u30DC\u30BF\u30F3\u3092\u62BC\u3057\u3066\u50CD\u753B\u3092\u30C9\u30E9\u30C3\u30B0\u3059\u308B",
    MINISCREEN: "\u5C0F\u3055\u306A\u753B\u9762",
    REFRESH: "\u30EA\u30D5\u30EC\u30C3\u30B7\u30E5",
    REFRESH_TIPS: "\u3057\u3066\u307F\u3066\u304F\u3060\u3055\u3044",
    FORWARD: "\u65E9\u9001\u308A",
    LIVE_TIP: "\u751F\u653E\u9001"
  }
};
export { jp as default };



//////////////////
// WEBPACK FOOTER
// ./node_modules/_xgplayer@3.0.5@xgplayer/es/lang/jp.js
// module id = null
// module chunks = 